// Module
var code = "<div class=\"site-version-label\"> <p class=\"short-version\">{{ vm.appNameTranslationKey | translate }} {{ vm.appVersion }} (embedded)</p> <p class=\"full-version\">{{ vm.fullVersionInfo }}</p> </div> ";
// Exports
module.exports = code;